export default __webpack_public_path__ + "static/media/wave.f6befb85.svg";